//
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
//component
//redux
//selector
//actions
import { snapDraftBailiffDetail } from "store/bailiff/draft/bailiff/draft_bailiff.action";
import {
  getAudioUrl,
  snapDraftDialogDetail,
  unSnapDraftDialogDetail,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import { setHighlight } from "store/bailiff/nav/nav.action";

export const TriggerDetail = () => {
  // -------------------------- VAR ----------------------------
  const params = useParams();
  const [searchParams, setSearchparams] = useSearchParams();
  const slot = searchParams.get("slot");
  const { bailiffId } = params;

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);

  useEffect(() => {
    if (bailiffId) {
      dispatch(snapDraftBailiffDetail({ bailiffId }));
    }

    return () => dispatch(unSnapDraftDialogDetail());
  }, [bailiffId, dispatch]);

  // sbap dialog
  useEffect(() => {
    if (bailiffId && slot) {
      const id = `${bailiffId}-${slot}`;
      dispatch(snapDraftDialogDetail({ dialogId: id }));
    }

    return () => dispatch(unSnapDraftDialogDetail());
  }, [bailiffId, slot, dispatch]);

  // GET AUDIO URL
  useEffect(() => {
    if (bailiffId && slot) {
      dispatch(getAudioUrl({ bailiff: bailiffId, part: slot }));
    }
  }, [bailiffId, slot, dispatch]);

  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerDetail;
